var React = require('react');

function Add (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"12","r":"12","transform":"rotate(90 12 12)","fill":"#EB5A30","key":0}),React.createElement("path",{"d":"M12 18.364V5.63609","stroke":"white","strokeWidth":"2","key":1}),React.createElement("path",{"d":"M5.63623 12L18.3642 12","stroke":"white","strokeWidth":"2","key":2})]);
}

Add.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Add;

Add.default = Add;
